import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "common-function" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "function-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "list-item-icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "list-item-name" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "division-line" }, null, -1)
const _hoisted_10 = { class: "all-function" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "function-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "list-item-icon" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "list-item-name" }
const _hoisted_17 = { class: "dialog-footer" }

import { setConfigApi } from '@/apis/user'
import { ref, Ref, watchEffect } from 'vue'
import { allFunctions2C, FunctionItems, allFunctions2B } from '../modules/data'
import { ElMessage } from 'element-plus'
import { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { isD2C, isJA, isEN, isKO } from '@/store'
import { t } from '@/plugins/i18n'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean, required: true },
    commonFunctionList: { type: Array, required: true }
  },
  emits: ['cancel', 'getCommonFunction'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean,
  commonFunctionList: FunctionItems[]
}
const icon_subtract = 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_subtract.png'
const icon_add = 'https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_add.png'


const commonFunctions: Ref<FunctionItems[]> = ref(props.commonFunctionList)
const allFunctions = isD2C() ? allFunctions2C : allFunctions2B
const _allFunctions: Ref<FunctionItems[]> = ref(allFunctions)

watchEffect(() => {
  commonFunctions.value = props.commonFunctionList
  _allFunctions.value = allFunctions.filter(item => !props.commonFunctionList.map(v => v.path).includes(item.path))
})

/** 添加常用功能 */
const addFunction = (item: FunctionItems) => {
  const addList: FunctionItems[] = [...new Set(commonFunctions.value)]
  if (addList?.length >= 5) {
    ElMessage.warning(t('最多添加5个常用功能'))
    return
  }
  addList.push(item)
  commonFunctions.value = addList
  _allFunctions.value = _allFunctions.value.filter(item => !addList.map(v => v.path).includes(item.path))
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'add_common_feature',
      menu_name: item.name
    }
  })
}

/** 删除常用功能 */
const subFunction = (item: FunctionItems) => {
  const targetObj = commonFunctions.value.find(v => v.path === item.path)
  if (targetObj) {
    commonFunctions.value = commonFunctions.value.filter(v => v.path !== targetObj.path)
    _allFunctions.value = allFunctions.filter(item => !commonFunctions.value.map(v => v.path).includes(item.path))
  }
}

const cancel = () => {
  emit('cancel')
  emit('getCommonFunction')
}

const saveSetConfig = async () => {
  if (!commonFunctions.value.length) {
    ElMessage.warning(t('请添加常用功能'))
    return
  }
  const configValue = JSON.stringify(commonFunctions.value)
  //   emit('cancel')
  const res = await setConfigApi({
    configCode: ENUM_CONFIG_CODE.WORKBENCH_MENU,
    configName: '',
    configValue
  })
  ElMessage.success(t('保存成功'))
  emit('cancel')
  emit('getCommonFunction')
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "show-close": false,
    width: "680px",
    "destroy-on-close": "",
    "custom-class": "dialog-common-function"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('常用功能')), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commonFunctions.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item",
                key: item.path,
                onClick: ($event: any) => (subFunction(item))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: item.icon,
                    class: "function-icon"
                  }, null, 8, _hoisted_7),
                  _createElementVNode("img", {
                    src: icon_subtract,
                    width: "16",
                    height: "16",
                    class: "icon_subtract",
                    referrerpolicy: "no-referrer"
                  })
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('全部功能')), 1),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_allFunctions.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.path
              }, [
                (!_unref(isD2C)() && _unref(isEN)() && ['SyncProduct', 'ReplenishmentList'].includes(item?.path as string))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                  : ((_unref(isEN)() || _unref(isKO)()) && ['CombinedGoods'].includes(item?.path as string))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                    : (!_unref(isD2C)() && _unref(isKO)() && ['ReplenishmentList'].includes(item?.path as string))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "list-item",
                          onClick: ($event: any) => (addFunction(item))
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: item.icon,
                              class: "function-icon"
                            }, null, 8, _hoisted_15),
                            _createElementVNode("img", {
                              src: icon_add,
                              width: "16",
                              height: "16",
                              class: "icon_add",
                              referrerpolicy: "no-referrer"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                        ], 8, _hoisted_13))
              ], 64))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_button, {
          type: "default",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveSetConfig
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})